import { styled } from '@mui/system';
import { CardContent } from '@mui/material';

const StyledCardContent = styled(CardContent)(({ offerThemeColor }) => ({
  background: offerThemeColor,
  p: '1.5rem',
  '&:last-child': {
    paddingBottom: 0,
  },
}));

export default StyledCardContent;
